<template>
  <Header/>
  <main>
    <RouterView/>
  </main>
  <Footer/>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&family=Poppins:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap');

.open400{
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
}

.open600{
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
}

.open700{
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
}

.pop300{
  font-family: 'Poppins', sans-serif;
  font-weight: 300;
}

.pop400{
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
}

.pop700{
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
}


.bg-bd-green{
  background-color: #70B224;
}

.bg-bd-orange{
  background-color: #FF9902;
}

.bg-bd-blue{
  background-color: #074CB2;
}
</style>

<script>
import HeaderView from './components/HeaderView.vue';
import FooterView from './components/FooterView.vue';

export default{
  name: 'App',
  components: {
    'Header' : HeaderView,
    'Footer' : FooterView
  }
}
</script>